module.exports = __webpack_public_path__ + "static/media/blue_loading.6f624306.svg";